export default __webpack_public_path__ + "static/media/laptop.cc106925.svg";